export function* ancestors(start: EventTarget | null) {
  if (start === null || !(start instanceof Node)) {
    return;
  }

  let current = start instanceof HTMLElement ? start : start.parentElement;
  for (; current !== null; current = current.parentElement) {
    yield current;
  }
}
